import React from 'react';
import { Button, LinearProgress, Box } from '@material-ui/core';
import pluralize from 'pluralize';
import styled from 'styled-components';
import ViewerErrorBoundary from '../../../common/ViewerConclusion/ViewerErrorBoundary';
import { QuestionText } from '../../QuestionViewer.styles';
export const BoxWithPadding = styled(Box) `
    padding-top: 3.5px;
    padding-bottom: 3.5px;
`;
const OptionButton = styled(Button) `
    min-height: 3.0625rem;
    justify-content: left;
    text-align: left;
    color: ${(props) => props.theme.colors.text};
    background-color: transparent;

    :hover {
        background-color: ${(props) => props.theme.colors.pollViewerBackgroundColorHover};
        color: ${(props) => props.theme.colors.pollViewerTextColorHover};
        border: 1px solid ${(props) => props.theme.colors.pollViewerBorderHover};
    }
`;
const ButtonWrapper = styled.div `
    position: relative;
    min-height: 3.0625rem;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.border};

    .MuiButton-label,
    .Mui-disabled {
        background-color: transparent;
    }

    .MuiButton-contained {
        box-shadow: none;
    }
`;
const ResponseStats = styled(LinearProgress) `
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background-color: transparent;

    .MuiLinearProgress-bar {
        background-color: ${(props) => props.theme.colors.pollViewerBackgroundColorHover};

        &:hover {
            color: ${(props) => props.theme.colors.pollViewerTextColorHover};
        }
    }
`;
const AnswerText = styled.div `
    flex-grow: 1;
    height: 100%;
    background-color: transparent;
    border: none;
`;
const TotalResponses = styled.div `
    display: flex;
    margin-top: 0.5rem;
    justify-content: flex-end;
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
`;
const PollQuestionViewer = ({ componentValues, setAnswer, answer = [], disabled }) => {
    var _a;
    const { question, answerOptions, allowMultiVotes, pollResponses } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const handleChange = (answerOptionKey) => {
        if (allowMultiVotes) {
            if (answer === null || answer === void 0 ? void 0 : answer.includes(answerOptionKey)) {
                const updated = answer === null || answer === void 0 ? void 0 : answer.filter((e) => e !== answerOptionKey);
                return setAnswer(updated);
            }
            const updated = [...(answer !== null && answer !== void 0 ? answer : []), answerOptionKey];
            return setAnswer(updated);
        }
        return setAnswer([answerOptionKey]);
    };
    const renderOptions = () => {
        if (answerOptions) {
            return answerOptions.map((possibleAnswer) => {
                var _a, _b;
                const optionHasPollResults = !!(pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses[possibleAnswer.key]);
                const optionPercentOfTotalResponses = (pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses) ? Math.floor((((_b = (_a = pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses[possibleAnswer.key]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) / (pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses)) *
                    100)
                    : 0;
                return (React.createElement(BoxWithPadding, { key: possibleAnswer.key },
                    React.createElement(ButtonWrapper, null,
                        React.createElement(OptionButton, { disabled: (!allowMultiVotes && !!(pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses)) || disabled, fullWidth: true, variant: (answer === null || answer === void 0 ? void 0 : answer.includes(possibleAnswer.key)) ? 'contained' : 'outlined', onClick: () => handleChange(possibleAnswer.key), "data-testid": `pollView-optionButton-${possibleAnswer.key}` },
                            React.createElement(React.Fragment, null,
                                React.createElement(AnswerText, { "data-testid": `pollView-answerText-${possibleAnswer.key}` }, possibleAnswer.text),
                                optionHasPollResults ? (React.createElement("div", { "data-testid": `pollView-responseStats-${possibleAnswer.key}` }, `${optionPercentOfTotalResponses}%`)) : null)),
                        optionHasPollResults ? (React.createElement(ResponseStats, { variant: "determinate", value: optionPercentOfTotalResponses, "aria-label": "Poll Results" })) : null)));
            });
        }
        return null;
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(QuestionText, { "data-testid": "pollView-question" }, question),
        allowMultiVotes && React.createElement("em", { "data-testid": "pollView-allowMultiVotes" }, "Multiple votes allowed"),
        renderOptions(),
        !!(pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses) && (pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses) >= 0 ? (React.createElement(TotalResponses, { "data-testid": "pollView-totalResponses" }, pluralize('response', (_a = pollResponses === null || pollResponses === void 0 ? void 0 : pollResponses.totalResponses) !== null && _a !== void 0 ? _a : 0, true))) : null));
};
export default PollQuestionViewer;
//# sourceMappingURL=index.js.map